module.exports = __webpack_public_path__ + "img/icons-set.cdf97a64.svg";